import clsx from 'clsx'
import React from 'react'

const knownAffiliateNetworkHostname = ['c3po.link', 'tidd.ly', 'lt45.net', 'www.awin1.com', 'lb.affilae.com', 'jdoqocy.com', 'financeads.net']

const soldLinks = [
  'https://www.decitre.fr/livres.html',
  'https://www.expertcn.fr/formation-installateur-irve-p1p2p3/',
]

interface ExternalLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
  href: string
  sponsored?: boolean
}

const ExternalLink: React.FC<ExternalLinkProps> = ({ href, children, sponsored = false, className, ...props }) => {
  const uri = new URL(href)
  sponsored = sponsored || (knownAffiliateNetworkHostname.indexOf(uri.hostname) !== -1 || uri.searchParams.has('ae') || uri.hash.includes('ae'))

  const isSoldLink = ['www.compeco.fr', ...soldLinks].includes(uri.toString())
  const followExternalLink = isSoldLink

  if (!sponsored && !isSoldLink && !uri.searchParams.has('ref') && !uri.searchParams.has('utm_source')) {
    uri.searchParams.append('utm_source', 'planete-durable')
  }

  let rel: React.HTMLAttributes<HTMLAnchorElement>['rel'] = undefined
  if (sponsored) {
    rel = 'sponsored nofollow'
  } else if (!followExternalLink) {
    rel = 'nofollow'
  }

  return (
    <a
      href={uri.toString()}
      target="_blank"
      className={clsx({
        'plausible-event-name=affiliateLinkClick': sponsored,
        'plausible-event-name=followExternalLinkClick': followExternalLink,
      }, className)}
      rel={rel}
      {...props}
    >
      {children}
    </a>
  )
}

export default ExternalLink
